/**
 * Metric names for MyHRLiteUIWebsite
 *
 * These metrics track kiosk authentication gateway events including
 * page loads, login attempts, and errors. All metrics include site_code
 * dimension for filtering by location.
 */
export enum MetricNames {
    // Page load metrics
    PAGE_LOAD = 'PageLoad',
    PAGE_LOAD_LATENCY = 'PageLoadLatency',

    // Login metrics
    LOGIN_BUTTON_CLICK = 'LoginButtonClick',

    // Error/failure metrics
    UNAUTHORIZED_PAGE_VIEW = 'UnauthorizedPageView',
    JAVASCRIPT_ERROR = 'JavaScriptError',

    // User interaction metrics
    LANGUAGE_CHANGE = 'LanguageChange',
    LANGUAGE_AUTO_RESET = 'LanguageAutoReset',

    // Health monitoring metrics
    KIOSK_HEARTBEAT = 'KioskHeartbeat',
}

/**
 * Dimension names used across metrics for consistent filtering
 */
export enum DimensionNames {
    SITE_CODE = 'site_code',
    LOGIN_METHOD = 'login_method',
    STAGE = 'stage',
    LOCALE = 'locale',
    PREVIOUS_LOCALE = 'previous_locale',
    ERROR_MESSAGE = 'error_message',
    ERROR_COMPONENT = 'error_component',
}

/**
 * Login method values
 */
export enum LoginMethodValues {
    MAASK = 'MAASK',
    ATOZ = 'ATOZ',
}
